<template>
<div id="marketing-modal">
  <el-dialog
    v-model="showMarketingModal"
    top="50%"
    custom-class="marketing-modal-modal"
    :close-on-click-modal="false">

    <div class="marketing-modal-box">
      <div class="marketing-modal-content" @click="gotoActivityUrl()">
        <img class="img" :src="marketingModalInfo.pc_pop_image" alt="">
      </div>
      <div class="close-btn" @click="closechargeCoupon()"><img src="../../../assets/imgs/coupon/modal-close.png"></div>
    </div>
  </el-dialog>
</div>
</template>


<script>
import sensorsdata from 'sa-sdk-javascript';

// 这个弹窗和首页下面的marketing-modal是一个逻辑，现在相当于首页用的是自己的，而国家页等其他的用的是这个，因为首页的不好改
import Http from '../../../libs/http';
import User from '../../../libs/user';

export default {
  name: 'marketing-modal',
  props: {
    shows_page_type_id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      pageTypeMap: {
        1: '首页',
        2: '签证国家页',
        3: '签证详情页',
        4: '我的',
      },
      showMarketingModal: false, // 显示营销弹窗
      marketingModalInfo: {}, // 当前营销弹窗的信息
      // 回调
      callback: {
        resolve: null,
        reject: null,
      },
    };
  },
  computed: {
  },
  watch: {
  },

  methods: {
    // 供外部调用
    initMarketingDialog() {
      return new Promise(async (resolve, reject) => {
        try {
          // 未登录，不弹出
          if (!User.isLogin()) return resolve();

          const { marketing_activity } = await Http.post('/marketing_activity_query', { shows_page_type_id: this.shows_page_type_id });
          if (!marketing_activity || !marketing_activity.length) return resolve();


          for (let index = 0; index < marketing_activity.length; index++) {
            const item = marketing_activity[index];
            // 如果已经显示过该活动弹窗，则不需要再次显示
            const marketingActivityStorage = localStorage.getItem('marketingActivity') && JSON.parse(localStorage.getItem('marketingActivity'));
            if (!marketingActivityStorage || !marketingActivityStorage[item.id]) {
              this.marketingModalInfo = item;
              this.showMarketingModal = true;
              this.callback.resolve = resolve;
              this.callback.reject = reject;

              sensorsdata.track('PopWindowExpose', {
                page_from: this.pageTypeMap[this.shows_page_type_id],
                activity_name: item.title,
                activity_id: item.id,
              });
              break;
            }
          }
          // 说明没有弹窗需要显示，则返回
          if (!this.showMarketingModal) {
            resolve();
          }
        } catch (error) {
          resolve();
        }
        
      });
    },
    // 关闭
    closechargeCoupon() {
      this.showMarketingModal = false;
      const marketingActivity = localStorage.getItem('marketingActivity') ? JSON.parse(localStorage.getItem('marketingActivity')) : {};
      marketingActivity[this.marketingModalInfo.id] = true;
      localStorage.setItem('marketingActivity', JSON.stringify(marketingActivity));
      // 回调出去
      this.callback.resolve && this.callback.resolve();
    },
    gotoActivityUrl() {
      if (this.marketingModalInfo.pc_jump_link) {
        sensorsdata.track('PopWindowClick', {
          page_from: this.pageTypeMap[this.shows_page_type_id],
          activity_name: this.marketingModalInfo.title,
          activity_id: this.marketingModalInfo.id,
        });
        window.open(this.marketingModalInfo.pc_jump_link);
      }
    },
  },

};
</script>

<style lang="less">
#marketing-modal {
  .marketing-modal-modal {
    transform: translate(-50%,-50%);
    width: 440px;
    // box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.2);
    box-shadow: none;
	  background: transparent;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      .marketing-modal-box {
        position: relative;
        display: flex;
        justify-content: center;
        .marketing-modal-content {
          position: relative;
          cursor: pointer;
          border-radius: 12px;
          overflow: hidden;
          .img {
            width: 100%;
          }
        }
        .close-btn {
          position: absolute;
          bottom: -81px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          justify-content: center;
          font-size: 0;
          cursor: pointer;
          img {
            width: 36px;
            height: 36px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/activity/dialog/marketing-dialog.vue